import * as AllColors from "../constants/colors";

export function createAccordionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "whiteRed";
  obj[AllColors["COLOR_LIGHTGREY"]] = "whiteRedOnLightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "whiteRedOnUltralightgrey";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoise";
  obj[AllColors["COLOR_RED"]] = "red";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "limeyellow";
  obj["default"] = "whiteRed";
  return obj;
}
export function createAnchorNavigationMapDefinition() {
  let obj = {};
  return obj;
}
export function createAnswerCardMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_LIGHTGREY"]] = "lightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "ultralightgrey";
  obj[AllColors["COLOR_RED"]] = "red";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoise";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "limeyellow";
  obj["default"] = "white";
  return obj;
}
export function createBadgeMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "darkgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "darkgrey";
  return obj;
}
export function createBreadcrumbMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "darkgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "darkgrey";
  return obj;
}
export function createBottomDrawerMapDefinition() {
  let obj = {};
  obj["default"] = "red";
  return obj;
}
export function createBulletListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "darkgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgreyOnLimeyellow";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "whiteOnBordeaux";
  obj["default"] = "darkgrey";
  return obj;
}
export function createBulletListDeprecatedMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "darkgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj["default"] = "darkgrey";
  return obj;
}
export function createBusinesscardAuthorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "darkgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj["default"] = "darkgrey";
  return obj;
}
export function createBusinesscardContactMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "red";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "white";
  obj[AllColors["COLOR_LIGHTGREY"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createBoxMapDefinition() {
  let obj = {};
  obj["default"] = "lightgrey";
  return obj;
}
export function createButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "red";
  obj[AllColors["COLOR_LIGHTGREY"]] = "redOnLightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "redOnUltralightgrey";
  obj[AllColors["COLOR_RED"]] = "redInverted";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeauxInverted";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoiseInverted";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "bordeaux";
  obj["default"] = "red";
  return obj;
}
export function createCaptionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "redActive";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoiseActive";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeauxActive";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "limeyellowActive";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "ultralightgreyActive";
  obj["default"] = "white";
  return obj;
}
export function createCardTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "ultralightgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "whiteOnLightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoiseDark";
  obj[AllColors["COLOR_RED"]] = "bordeaux";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeauxDark";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "whiteOnLimeyellow";
  obj["default"] = "ultralightgrey";
  return obj;
}
export function createCarouselMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "turquoise";
  obj[AllColors["COLOR_LIGHTGREY"]] = "red";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "turquoise";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoiseInverted";
  obj[AllColors["COLOR_RED"]] = "redInverted";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeauxInverted";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "bordeaux";
  obj["default"] = "turquoise";
  return obj;
}
export function createCheckboxMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "turquoise";
  obj[AllColors["COLOR_LIGHTGREY"]] = "red";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "turquoise";
  obj[AllColors["COLOR_TURQUOISE"]] = "inverted";
  obj[AllColors["COLOR_RED"]] = "inverted";
  obj[AllColors["COLOR_BORDEAUX"]] = "inverted";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "turquoise";
  return obj;
}
export function createClickableImageMapDefinition() {
  let obj = {};
  obj["default"] = "turquoise";
  return obj;
}
export function createColorSeparatorMapDefinition() {
  let obj = {};
  return obj;
}
export function createCompassMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "white";
  obj[AllColors["COLOR_LIGHTGREY"]] = "white";
  obj[AllColors["COLOR_WHITE"]] = "ultralightgrey";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createContactBarMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createContactLayerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "turquoiseDark";
  obj["default"] = "turquoiseDark";
  return obj;
}
export function createContactListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "darkgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "darkgrey";
  return obj;
}
export function createContentAggregatorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "turquoise";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "turquoise";
  obj[AllColors["COLOR_LIGHTGREY"]] = "red";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoiseInverted";
  obj[AllColors["COLOR_RED"]] = "redInverted";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeauxInverted";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "turquoise";
  return obj;
}
export function createContentAggregatorItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "ultralightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "white";
  obj[AllColors["COLOR_LIGHTGREY"]] = "white";
  obj[AllColors["COLOR_RED"]] = "whiteOnRed";
  obj[AllColors["COLOR_TURQUOISE"]] = "whiteOnTurquoise";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "whiteOnLimeyellow";
  obj[AllColors["COLOR_BORDEAUX"]] = "whiteOnBordeaux";
  obj["default"] = "white";
  return obj;
}
export function createContextMenuMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createContextMenuItemMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createDataTableMapDefinition() {
  let obj = {};
  return obj;
}
export function createDateEventMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "darkgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "darkgrey";
  return obj;
}
export function createDatePickerMapDefinition() {
  let obj = {};
  return obj;
}
export function createDividerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "darkgrey";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj["default"] = "darkgrey";
  return obj;
}
export function createDropdownMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "turquoise";
  obj[AllColors["COLOR_LIGHTGREY"]] = "turquoiseOnLightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "turquoiseOnUltralightgrey";
  obj[AllColors["COLOR_TURQUOISE"]] = "whiteOnTurquoise";
  obj[AllColors["COLOR_RED"]] = "whiteOnRed";
  obj[AllColors["COLOR_BORDEAUX"]] = "whiteOnBordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgreyOnLimeyellow";
  obj["default"] = "turquoise";
  return obj;
}
export function createDropdownOptionMapDefinition() {
  let obj = {};
  obj["default"] = "turquoise";
  return obj;
}
export function createErrorMessageMapDefinition() {
  let obj = {};
  obj["default"] = "bordeaux";
  return obj;
}
export function createFileUploadMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "lightgreyOnWhite";
  obj[AllColors["COLOR_LIGHTGREY"]] = "turquoiseOnLightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "turquoiseOnUltralightgrey";
  obj[AllColors["COLOR_RED"]] = "whiteOnRed";
  obj[AllColors["COLOR_TURQUOISE"]] = "whiteOnTurquoise";
  obj[AllColors["COLOR_BORDEAUX"]] = "whiteOnBordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "turquoiseOnYellow";
  obj["default"] = "lightgreyOnWhite";
  return obj;
}
export function createFilePreviewMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_RED"]] = "red";
  obj[AllColors["COLOR_TURQUOISE"]] = "red";
  obj[AllColors["COLOR_BORDEAUX"]] = "red";
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj["default"] = "red";
  return obj;
}
export function createFooterBarMapDefinition() {
  let obj = {};
  return obj;
}
export function createFormMessageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "standard";
  obj[AllColors["COLOR_LIGHTGREY"]] = "standard";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "standard";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "standard";
  return obj;
}
export function createHeadlineMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "red";
  obj[AllColors["COLOR_LIGHTGREY"]] = "red";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "red";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "bordeaux";
  obj["default"] = "red";
  return obj;
}
export function createIconMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "darkgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "darkgrey";
  return obj;
}
export function createImageMapDefinition() {
  let obj = {};
  return obj;
}
export function createInfoIconMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "darkgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj[AllColors["COLOR_DARKGREY"]] = "redInverted";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj["default"] = "darkgrey";
  return obj;
}
export function createInputMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "turquoise";
  obj[AllColors["COLOR_LIGHTGREY"]] = "turquoiseOnLightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "turquoiseOnUltralightgrey";
  obj[AllColors["COLOR_RED"]] = "whiteOnRed";
  obj[AllColors["COLOR_TURQUOISE"]] = "whiteOnTurquoise";
  obj[AllColors["COLOR_BORDEAUX"]] = "whiteOnBordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgreyOnLimeyellow";
  obj["default"] = "turquoise";
  return obj;
}
export function createLinkMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "red";
  obj[AllColors["COLOR_LIGHTGREY"]] = "red";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "red";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "bordeaux";
  obj["default"] = "red";
  return obj;
}
export function createLinklistMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "red";
  obj[AllColors["COLOR_LIGHTGREY"]] = "red";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "red";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "bordeaux";
  obj["default"] = "red";
  return obj;
}
export function createMapMapDefinition() {
  let obj = {};
  return obj;
}
export function createMapInfoLayerMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createModalMapDefinition() {
  let obj = {};
  return obj;
}
export function createMultiContentStageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "white";
  obj[AllColors["COLOR_LIGHTGREY"]] = "white";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "white";
  obj[AllColors["COLOR_WHITE"]] = "ultralightgrey";
  obj["default"] = "white";
  return obj;
}
export function createNavigationMapDefinition() {
  let obj = {};
  return obj;
}
export function createNumberMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "red";
  obj[AllColors["COLOR_LIGHTGREY"]] = "red";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "red";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "bordeaux";
  obj["default"] = "red";
  return obj;
}
export function createOffsetTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "ultralightgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "whiteOnLightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "whiteOnTurquoise";
  obj[AllColors["COLOR_RED"]] = "bordeaux";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeauxDark";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "whiteOnLimeyellow";
  obj["default"] = "ultralightgrey";
  return obj;
}
export function createOffsetTeaser5MapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "ultralightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "white";
  obj[AllColors["COLOR_LIGHTGREY"]] = "whiteOnLightgrey";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "whiteOnLimeyellow";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoiseDark";
  obj[AllColors["COLOR_RED"]] = "bordeaux";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeauxDark";
  obj["default"] = "ultralightgrey";
  return obj;
}
export function createPreloaderCircleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "colorful";
  obj[AllColors["COLOR_LIGHTGREY"]] = "colorful";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "colorful";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "colorful";
  return obj;
}
export function createPreloaderSquaresMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_WHITE"]] = "red";
  obj[AllColors["COLOR_LIGHTGREY"]] = "red";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "red";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "red";
  return obj;
}
export function createProgressCircleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_RED"]] = "red";
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "yellow";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoise";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeaux";
  obj[AllColors["COLOR_LIGHTGREY"]] = "lightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "ultralightgrey";
  obj["default"] = "white";
  return obj;
}
export function createPromoFlagMapDefinition() {
  let obj = {};
  obj["default"] = "bordeaux";
  return obj;
}
export function createPageHeaderMapDefinition() {
  let obj = {};
  obj["default"] = "red";
  return obj;
}
export function createPictogramMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "red";
  obj[AllColors["COLOR_LIGHTGREY"]] = "red";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "red";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "bordeaux";
  obj["default"] = "red";
  return obj;
}
export function createRadioButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "turquoise";
  obj[AllColors["COLOR_LIGHTGREY"]] = "turquoise";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "turquoise";
  obj[AllColors["COLOR_RED"]] = "inverted";
  obj[AllColors["COLOR_TURQUOISE"]] = "inverted";
  obj[AllColors["COLOR_BORDEAUX"]] = "inverted";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "turquoise";
  return obj;
}
export function createReadMoreMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_LIGHTGREY"]] = "darkgreyOnLightgrey";
  obj[AllColors["COLOR_TURQUOISE"]] = "whiteOnTurquoise";
  obj[AllColors["COLOR_RED"]] = "whiteOnRed";
  obj[AllColors["COLOR_BORDEAUX"]] = "whiteOnBordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgreyOnLimeyellow";
  obj["default"] = "darkgreyOnWhite";
  return obj;
}
export function createRteRendererMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "red";
  obj[AllColors["COLOR_LIGHTGREY"]] = "red";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "red";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "bordeaux";
  obj["default"] = "red";
  return obj;
}
export function createSectionMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createSearchResultItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "ultralightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "whiteWithLightGreyDescription";
  obj[AllColors["COLOR_LIGHTGREY"]] = "whiteWithUltralightGreyDescription";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "white75";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj["default"] = "ultralightgrey";
  return obj;
}
export function createSitelinkMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "whiteRed";
  obj[AllColors["COLOR_LIGHTGREY"]] = "whiteRedOnLightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "whiteRedOnUltralightgrey";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoise";
  obj[AllColors["COLOR_RED"]] = "red";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "limeyellow";
  obj["default"] = "whiteRed";
  return obj;
}
export function createSliderMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "turquoise";
  obj[AllColors["COLOR_LIGHTGREY"]] = "turquoise";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "turquoise";
  obj[AllColors["COLOR_TURQUOISE"]] = "whiteOnTurquoise";
  obj[AllColors["COLOR_RED"]] = "whiteOnRed";
  obj[AllColors["COLOR_BORDEAUX"]] = "whiteOnBordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgreyOnLimeyellow";
  obj["default"] = "turquoise";
  return obj;
}
export function createSwitchToggleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "turquoise";
  obj[AllColors["COLOR_LIGHTGREY"]] = "turquoise";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "turquoise";
  obj[AllColors["COLOR_RED"]] = "inverted";
  obj[AllColors["COLOR_TURQUOISE"]] = "inverted";
  obj[AllColors["COLOR_BORDEAUX"]] = "inverted";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "turquoise";
  return obj;
}
export function createSpacerMapDefinition() {
  let obj = {};
  return obj;
}
export function createStageMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createStepMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "turquoise";
  obj[AllColors["COLOR_LIGHTGREY"]] = "redOnLightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "turquoise";
  obj[AllColors["COLOR_TURQUOISE"]] = "whiteOnTurquoise";
  obj[AllColors["COLOR_RED"]] = "whiteOnRed";
  obj[AllColors["COLOR_BORDEAUX"]] = "whiteOnBordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "whiteOnLimeyellow";
  obj["default"] = "turquoise";
  return obj;
}
export function createStepsMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "turquoise";
  obj[AllColors["COLOR_LIGHTGREY"]] = "redOnLightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "turquoise";
  obj[AllColors["COLOR_TURQUOISE"]] = "whiteOnTurquoise";
  obj[AllColors["COLOR_RED"]] = "whiteOnRed";
  obj[AllColors["COLOR_BORDEAUX"]] = "whiteOnBordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "whiteOnLimeyellow";
  obj["default"] = "turquoise";
  return obj;
}
export function createTableRendererMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "whiteRedHighlighting";
  obj[AllColors["COLOR_LIGHTGREY"]] = "lightgreyRedHighlighting";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "ultralightgreyRedHighlighting";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoise";
  obj[AllColors["COLOR_RED"]] = "red";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "limeyellow";
  obj["default"] = "whiteRedHighlighting";
  return obj;
}
export function createTabsMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_LIGHTGREY"]] = "lightgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "ultralightgrey";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoise";
  obj[AllColors["COLOR_RED"]] = "red";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "limeyellow";
  obj["default"] = "white";
  return obj;
}
export function createTagPillMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "red";
  obj[AllColors["COLOR_LIGHTGREY"]] = "red";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "red";
  obj[AllColors["COLOR_RED"]] = "whiteOnRed";
  obj[AllColors["COLOR_TURQUOISE"]] = "whiteOnTurquoise";
  obj[AllColors["COLOR_BORDEAUX"]] = "whiteOnBordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "red";
  return obj;
}
export function createTextMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "darkgrey";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "darkgrey";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "darkgrey";
  obj["default"] = "white";
  return obj;
}
export function createTextTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "ultralightgrey";
  obj[AllColors["COLOR_LIGHTGREY"]] = "white";
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "white";
  obj[AllColors["COLOR_TURQUOISE"]] = "white";
  obj[AllColors["COLOR_RED"]] = "white";
  obj[AllColors["COLOR_BORDEAUX"]] = "white";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "white";
  obj["default"] = "ultralightgrey";
  return obj;
}
export function createThirdLevelNavigationMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "ultralightgrey";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoise";
  obj[AllColors["COLOR_RED"]] = "red";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeaux";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "limeyellow";
  obj["default"] = "ultralightgrey";
  return obj;
}
export function createThirdLevelNavigationItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_ULTRALIGHTGREY"]] = "ultralightgrey";
  obj[AllColors["COLOR_RED"]] = "red";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoise";
  obj[AllColors["COLOR_LIMEYELLOW"]] = "limeyellow";
  obj[AllColors["COLOR_BORDEAUX"]] = "bordeaux";
  obj["default"] = "ultralightgrey";
  return obj;
}
export function createTilesTeaserMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createTooltipMapDefinition() {
  let obj = {};
  obj["default"] = "darkgrey";
  return obj;
}
export function createVideoplayerMapDefinition() {
  let obj = {};
  obj["default"] = "red";
  return obj;
}
export function createViolatorMapDefinition() {
  let obj = {};
  obj["default"] = "black";
  return obj;
}
